exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".speed-list-popover{min-width:80px;background:rgba(16,58,68,.69);border:none;-webkit-box-shadow:inset 0 0 142px 0 #06333d;box-shadow:inset 0 0 142px 0 #06333d}.speed-list-popover .speed-popover-content{text-align:center;color:#fff;line-height:28px}.speed-list-popover .speed-popover-content .cur-speed{color:#3cf8ed}", ""]);

// exports
